import { useOrganisation } from "../contexts/OrganisationContext";

export function OrgSwitcher() {
  const { organisation } = useOrganisation();

  if (!organisation) {
    return (
      <span className="text-xs text-slate-500 dark:text-slate-400">No active organisation</span>
    );
  }

  // For Sprint 1 this is a read-only display. Multi-org switching ships in a
  // later sprint when /auth/me + /auth/switch-org are wired up to a dropdown.
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm font-semibold text-slate-900 dark:text-slate-100">
        {organisation.name}
      </span>
      <span className="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide text-slate-600 dark:bg-slate-800 dark:text-slate-300">
        {organisation.tier.replace("_", " ")}
      </span>
    </div>
  );
}
